import { createApp } from 'vue'
import { Button, Image, Icon, Radio, RadioGroup, Picker, Popup, NavBar, Checkbox, DatePicker } from 'vant';
import 'vant/lib/index.css';
import { installOrderTheme } from './utils/order-theme'
import './styles/order-theme.scss'
import App from './App.vue'
import store from './store/index'
// 路由
import router from './router'
import tim from '@/tim'
import axios from '@/utils/axios'
import API from '@/api'
// 共通filters
import * as filters from './filters'
// 设置字体大小
// import '@/utils/rem';
import '@/common/permission'
// 全局css
import '@/styles/index.scss'
// 公共插件引入
// import { setupViewer } from './utils/commonPlugin'
import 'amfe-flexible/index'
import mitt from 'mitt'
installOrderTheme(router, axios, () => store.getters.urlParams || {})

const emitter = mitt()
const app = createApp(App)

app.config.globalProperties.$bus = emitter
app.config.globalProperties.tim = tim
app.config.globalProperties.$_http = axios
app.config.globalProperties.$_API = API

Object.entries(filters).forEach(([key, value]) => {
  app.config.globalProperties[`$${key}`] = value
})

app.use(router)
app.use(Button);
app.use(Image);
app.use(Icon);
app.use(Radio);
app.use(RadioGroup);
app.use(Picker);
app.use(Popup);
app.use(NavBar);
app.use(Checkbox);
app.use(DatePicker);
app.use(store)
app.component(Button.name, Button);
app.component(Image.name, Image);
app.component(Icon.name, Icon);
app.component(Radio.name, Radio);
app.component(RadioGroup.name, RadioGroup);
app.component(Picker.name, Picker);
app.component(Popup.name, Popup);
app.component(NavBar.name, NavBar);
app.component(Checkbox.name, Checkbox);
app.mount('#app')
